import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ApiService } from '../api.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
	selector: 'report',
	templateUrl: './report.component.html',
	styleUrls: ['./report.component.scss']
})

export class ReportComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() type = ''
	@Input() course = 0
	@Input() name = ''
	typeStr = ''
	writer = ''
	reportLink = ''

	generating = false
	generateSuccess = false
	generateError = false

	generateReportSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService) {}

	ngOnInit(): void {}
	
	ngAfterViewInit(): void {}
	
	ngOnChanges(): void {
		this.generating = false
		this.generateSuccess = false
		this.generateError = false
		this.reportLink = ''

		switch (this.type) {
			case 'casestudiesReport':
				this.typeStr = 'Casos Prácticos'
				break
			case 'evaluationsReport':
				this.typeStr = 'Evaluaciones'
				break
			case 'courseStructure':
				this.typeStr = 'Estructura del curso'
				break
			case 'courseStructureWithoutHeadings':
				this.typeStr = 'Estructura del curso (sin enunciados)'
				break
			case 'courseStructureWithActivities':
				this.typeStr = 'Estructura del curso (con actividades)'
				break
			case 'courseStructureWithActivitiesWithoutHeadings':
				this.typeStr = 'Estructura del curso (con actividades y sin enunciados)'
				break
		}
	}
	
	ngOnDestroy(): void {
		this.generateReportSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	generate() {
		if (this.writer == '') {
			Swal.fire('Error', 'Por favor, seleccione el formato del informe a generar.', 'error')
			return
		}

		this.generating = true
		this.generateSuccess = false
		this.generateError = false

		// console.log(this.course)
		// console.log(this.type)
		// console.log(this.writer)

		this.generateReportSub = this.dataService.generateReport(this.course, this.type, this.writer)
		.subscribe(
			data => {
				console.log(data)
				let status = data.status
				if (status == 'success') {
					this.generating = false
					this.generateSuccess = true
					this.generateError = false

					this.reportLink = data.message.replace('../..', this.dataService.phpBrainscormUrl)
				} else {
					this.generating = false
					this.generateSuccess = false
					this.generateError = true

					this.reportLink = ''
				}
			},
			error => {
				console.log(error)
				this.generating = false
				this.generateSuccess = false
				this.generateError = true
			},
		)
	}

}
